import { vMaska } from "maska/vue";
import { tokens } from "maska";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("maska", vMaska);
  nuxtApp.vueApp.directive("maska-tokens", tokens);
});